import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Text,
  useColorModeValue,
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  CircularProgress,
  CircularProgressLabel,
  Spinner,
  Center,
  Tooltip,
  Icon,
  VStack,
  HStack,
} from "@chakra-ui/react";
import Card from "../../../../components/card/Card";
import { campaignService } from "../../../../services/campaignService";
import { MdInfo } from "react-icons/md";

export default function CampaignEffectiveness({ campaignData = null }) {
  const [loading, setLoading] = useState(true);
  const [campaignStats, setCampaignStats] = useState(null);
  
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const bgStat = useColorModeValue("gray.50", "navy.700");
  
  useEffect(() => {
    const fetchCampaignStats = async () => {
      try {
        setLoading(true);
        const response = await campaignService.getCampaignStats();
        
        if (response.success) {
          setCampaignStats(response.data);
        } else {
          setCampaignStats({
            active: 0,
            passive: 0,
            total: 0,
            effectiveness: 0,
            totalViews: 0
          });
        }
      } catch (error) {
        console.error('Kampanya istatistikleri getirme hatası:', error);
        setCampaignStats({
          active: 0,
          passive: 0,
          total: 0,
          effectiveness: 0,
          totalViews: 0
        });
      } finally {
        setLoading(false);
      }
    };
    
    // Eğer campaignData prop'u verilmemişse, API'den verileri çek
    if (!campaignData) {
      fetchCampaignStats();
    } else {
      setCampaignStats(campaignData);
      setLoading(false);
    }
  }, [campaignData]);
  
  if (loading) {
    return (
      <Card h="100%">
        <Text color={textColor} fontSize="lg" fontWeight="700" mb="4">
          Kampanya Etkinliği
        </Text>
        <Center py={8}>
          <Spinner color="brand.500" />
        </Center>
      </Card>
    );
  }
  
  return (
    <Card h="100%">
      <Flex direction="column" h="100%" justify="space-between">
        <HStack spacing={2} mb="4">
          <Text color={textColor} fontSize="lg" fontWeight="700">
            Kampanya Etkinliği
          </Text>
          <Tooltip 
            label="Etkinlik puanı, kampanyaların görüntülenme sayısına göre hesaplanır. 100 puan maksimum etkinliği gösterir." 
            placement="top"
            hasArrow
            bg="gray.700"
            color="white"
            fontSize="sm"
            openDelay={300}
          >
            <Box display="inline-block">
              <Icon as={MdInfo} w="16px" h="16px" color="gray.400" cursor="pointer" />
            </Box>
          </Tooltip>
        </HStack>
        
        <Flex direction="column" align="center" mb={4}>
          <CircularProgress 
            value={campaignStats.effectiveness} 
            size="120px" 
            thickness="8px"
            color={campaignStats.effectiveness >= 70 ? "green.400" : campaignStats.effectiveness >= 50 ? "orange.400" : "red.400"}
          >
            <CircularProgressLabel>{campaignStats.effectiveness}%</CircularProgressLabel>
          </CircularProgress>
          <Text fontSize="sm" mt={2}>Kampanya Etkinliği</Text>
        </Flex>
        
        <VStack spacing={3} align="stretch" mb={2}>
          <Flex justify="space-between" p={3} borderRadius="md" bg={bgStat}>
            <Text fontSize="sm">Aktif Kampanyalar</Text>
            <Text fontSize="sm" fontWeight="bold">{campaignStats.active}</Text>
          </Flex>
          
          <Flex justify="space-between" p={3} borderRadius="md" bg={bgStat}>
            <Text fontSize="sm">Pasif Kampanyalar</Text>
            <Text fontSize="sm" fontWeight="bold">{campaignStats.passive}</Text>
          </Flex>
          
          <Flex justify="space-between" p={3} borderRadius="md" bg={bgStat}>
            <Text fontSize="sm">Toplam Görüntülenme</Text>
            <Text fontSize="sm" fontWeight="bold">{campaignStats.totalViews.toLocaleString()}</Text>
          </Flex>
        </VStack>
      </Flex>
    </Card>
  );
} 